// removed by extract-text-webpack-plugin
module.exports = {"btn":"_3qFK-Ki35nGIKcQY9XI49F","gusa":"vWlm8u1PBE68VWsBZ9618","ottica":"_2V4heHOLQXLkZNB_ryZywf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Button/button.scss
// module id = 191
// module chunks = 0